import {
  GET_INVESTOR_TYPE_INIT,
  GET_INVESTOR_TYPE_SUCCESS,
  GET_INVESTOR_TYPE_FAILED,
  GET_CURRENT_USER_DETAILS_INIT,
  GET_CURRENT_USER_DETAILS_SUCCESS,
  GET_CURRENT_USER_DETAILS_FAILED,
  UPDATE_USER_PROFILE_INIT,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAILED,
  UPDATE_USER_PASSWORD_INIT,
  UPDATE_USER_PASSWORD_SUCCESS,
  UPDATE_USER_PASSWORD_FAILED,
} from "./constants";

const initialState = {
  loading: false,
  userloader: false,
  getInvestors: [],
  getCurrentUser: {},
  updateUser: {},
  passLoader: false,
};

export default function userDetails(state = initialState, action) {
  switch (action.type) {
    case GET_INVESTOR_TYPE_INIT:
      return { ...state, loading: true };
    case GET_INVESTOR_TYPE_SUCCESS:
      return { ...state, loading: false, getInvestors: action.payload };
    case GET_INVESTOR_TYPE_FAILED:
      return { ...state, loading: false };
    case GET_CURRENT_USER_DETAILS_INIT:
      return { ...state, loading: true };
    case GET_CURRENT_USER_DETAILS_SUCCESS:
      return { ...state, loading: false, getCurrentUser: action.payload };
    case GET_CURRENT_USER_DETAILS_FAILED:
      return { ...state, loading: false };
    case UPDATE_USER_PROFILE_INIT:
      return { ...state, userloader: true };
    case UPDATE_USER_PROFILE_SUCCESS:
      return { ...state, userloader: false, updateUser: action.payload };
    case UPDATE_USER_PROFILE_FAILED:
      return { ...state, userloader: false };

    case UPDATE_USER_PASSWORD_INIT:
      return { ...state, passLoader: true };
    case UPDATE_USER_PASSWORD_SUCCESS:
      return { ...state, passLoader: false, changePassword: action.payload };
    case UPDATE_USER_PASSWORD_FAILED:
      return { ...state, passLoader: false };
    default:
      return state;
  }
}
